import { useActions } from '../../../../hooks/useActions';
import { useEffect, useState } from 'react';
import fireToast from '../../../benit/central-ui/methods/fireToast';

const WiderrufPage = () => {
    const [request, setRequest] = useState<{ [x: string]: string }>({
        anrede: 'Anrede',
        firstName: '',
        lastName: '',
        eMail: '',
        telephone: '',
        street: '',
        postcode: '',
        city: '',
        contractDate: '',
        objectDescription: '',
        customText: '',
    });
    const [requestSuccessful, setRequestSuccessful] = useState(false);

    const { ri_homepage_send_request } = useActions();

    useEffect(() => {
        // @ts-ignore
        new HSStickyBlock('.js-sticky-block', {
            // @ts-ignore
            targetSelector: '#header',
        });
    }, []);

    useEffect(() => {
        if (requestSuccessful) {
            fireToast('success', `Widerruf erfolgreich übermittelt`);
        }
    }, [requestSuccessful]);

    const sendWiderruf = () => {
        // Build the declaration as flowing prose: the general-request email template
        // renders {{customText}} in a single HTML cell where newlines collapse, so we
        // keep everything on one readable line rather than label/value rows.
        const consumerName = `${request.anrede !== 'Anrede' ? request.anrede + ' ' : ''}${request.firstName} ${request.lastName}`.trim();
        const address = [request.street, [request.postcode, request.city].filter(Boolean).join(' ')].filter(Boolean).join(', ');

        const declaration =
            `WIDERRUF DES MAKLERVERTRAGES — ` +
            `Hiermit widerrufe ich, ${consumerName}` +
            (address ? `, wohnhaft ${address}` : '') +
            `, den ${request.contractDate ? `am ${request.contractDate} ` : ''}mit der Rauprecht Immobilien GmbH abgeschlossenen Maklervertrag` +
            (request.objectDescription ? ` (Objekt/Vertrag: ${request.objectDescription})` : '') +
            `.` +
            (request.customText ? ` Weitere Mitteilung: ${request.customText}` : '');

        ri_homepage_send_request(
            request.anrede,
            request.firstName,
            request.lastName,
            request.eMail,
            request.telephone,
            declaration,
            null,
            'Widerruf',
            request.street,
            request.postcode,
            request.city
        );
        setRequestSuccessful(true);
    };

    return (
        <>
            <div className="container">
                {/* Heading */}
                <div className="w-md-80 w-lg-50 text-center mx-md-auto">
                    <span className="d-block small font-weight-bold text-cap mb-2">Verbraucherinformation</span>
                    <h2>Allgemeiner Hinweis zum Widerrufsrecht</h2>
                </div>

                <div className="row">
                    <div className={`${requestSuccessful ? 'col-lg-12' : 'col-lg-8'}`}>
                        <div className="row align-items-md-center mt-7">
                            <div className="col-md-12">
                                <ul className="list-unstyled list-pointer">
                                    <li className="list-item mb-5">
                                        Verbraucher, die mit uns als Immobilienbüro einen Maklervertrag abschließen, haben grundsätzlich ein gesetzliches Widerrufsrecht innerhalb einer 14-tägigen
                                        Widerrufsfrist. Gewerbetreibenden/Firmen steht dieses Widerrufsrecht nicht zu. Das Widerrufsrecht kann bei vollständiger Erbringung der Dienstleistung durch uns
                                        erlöschen. Sie haben dazu im Zusammenhang des Abschlusses des Maklervertrages mit uns (an anderer Stelle) entsprechende Erklärungen zum Erhalt der
                                        Widerrufs-Belehrung, des Muster-Widerrufsformulars und der Aufforderung zur sofortigen Tätigkeit abgegeben. Die folgende Widerrufsbelehrung dient deshalb
                                        Informationszwecken. Wir prüfen nach einem gegenüber uns erklärten Widerruf, ob der Widerruf wirksam erklärt worden ist.
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="row align-items-md-center mt-5">
                            <div className="col-md-12">
                                <div className="mb-5">
                                    <h3 className="mb-3">Widerrufsrecht</h3>
                                </div>
                                <ul className="list-unstyled list-pointer">
                                    <li className="list-item mb-3">
                                        Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des
                                        Vertragsabschlusses.
                                    </li>
                                    <li className="list-item mb-3">
                                        Um Ihr Widerrufsrecht auszuüben, müssen Sie uns Rauprecht Immobilien GmbH, Dorfstrasse 42, 16321 Bernau mittels einer eindeutigen Erklärung (z. B. ein mit der
                                        Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.
                                    </li>
                                    <li className="list-item mb-3">
                                        Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist. Sie können Ihr Widerrufsrecht auch online unter:
                                        www.rauprecht-immobilien.de oder anderen geeigneten Hinweis darüber eingeben, wo die Widerrufsfunktion verfügbar ist ausüben.
                                    </li>
                                    <li className="list-item mb-3">
                                        Wenn Sie diese Online-Funktion nutzen, übermitteln wir Ihnen auf einem dauerhaften Datenträger (z. B. durch eine E-Mail) unverzüglich eine Eingangsbestätigung
                                        mit Informationen zum Inhalt der Widerrufserklärung sowie dem Datum und der Uhrzeit ihres Eingangs. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die
                                        Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="row align-items-md-center mt-5">
                            <div className="col-md-12">
                                <div className="mb-5">
                                    <h3 className="mb-3">Folgen des Widerrufs</h3>
                                </div>
                                <ul className="list-unstyled list-pointer">
                                    <li className="list-item mb-3">
                                        Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der
                                        zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstige Standardlieferung gewählt haben),
                                        unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist.
                                        Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde
                                        ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnen.
                                    </li>
                                    <li className="list-item mb-3">
                                        Haben Sie verlangt, dass die Dienstleistung während der Widerrufsfrist beginnen soll, so haben Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil der bis
                                        zu dem Zeitpunkt, zu dem Sie uns von der Ausübung des Widerrufsrechts hinsichtlich dieses Vertrags unterrichten, bereits erbrachten Dienstleistungen im Vergleich
                                        zum Gesamtumfang der im Vertrag vorgesehenen Dienstleistungen entspricht.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className={`${requestSuccessful ? 'd-none' : 'col-lg-4'}`}>
                        {/* Sticky Block */}
                        <div id="stickyBlockStartPointWiderruf">
                            <div
                                className="js-sticky-block"
                                data-hs-sticky-block-options='{
                          "parentSelector": "#stickyBlockStartPointWiderruf",
                          "breakpoint": "lg",
                          "startPoint": "#stickyBlockStartPointWiderruf",
                          "endPoint": "#stickyBlockEndPointWiderruf",
                          "stickyOffsetTop": 24,
                          "stickyOffsetBottom": 0
                          }'
                            >
                                {/* Card */}
                                <div className="card card-bordered">
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <h4 className="card-title">Vertrag widerrufen</h4>
                                            <p className="small text-muted mb-0">
                                                Bitte geben Sie die nachstehenden Angaben ein und schließen Sie den Widerruf anschließend mit „Widerruf bestätigen“ ab.
                                            </p>
                                        </div>
                                        {/* Form */}
                                        <form>
                                            <select
                                                className="form-select mb-2"
                                                onChange={(e: any) => setRequest({ ...request, anrede: e.target.value })}
                                                value={request && request.anrede ? request.anrede : 'Anrede'}
                                            >
                                                <option value="Anrede">Anrede</option>
                                                <option value="Frau">Frau</option>
                                                <option value="Herr">Herr</option>
                                            </select>
                                            <div className="mb-2">
                                                <label htmlFor="widerrufFirstName" className="form-label visually-hidden">
                                                    Vorname
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="widerrufFirstName"
                                                    placeholder="Vorname"
                                                    aria-label="Vorname"
                                                    value={request.firstName ? request.firstName : ''}
                                                    onChange={(e: any) => setRequest({ ...request, firstName: e.target.value })}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label htmlFor="widerrufLastName" className="form-label visually-hidden">
                                                    Nachname
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="widerrufLastName"
                                                    placeholder="Nachname"
                                                    aria-label="Nachname"
                                                    value={request.lastName ? request.lastName : ''}
                                                    onChange={(e: any) => setRequest({ ...request, lastName: e.target.value })}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label htmlFor="widerrufStreet" className="form-label visually-hidden">
                                                    Straße und Hausnummer
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="widerrufStreet"
                                                    placeholder="Straße und Hausnummer"
                                                    aria-label="Straße und Hausnummer"
                                                    value={request.street ? request.street : ''}
                                                    onChange={(e: any) => setRequest({ ...request, street: e.target.value })}
                                                />
                                            </div>
                                            <div className="row">
                                                <div className="col-4 mb-2">
                                                    <label htmlFor="widerrufPostcode" className="form-label visually-hidden">
                                                        PLZ
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="widerrufPostcode"
                                                        placeholder="PLZ"
                                                        aria-label="PLZ"
                                                        value={request.postcode ? request.postcode : ''}
                                                        onChange={(e: any) => setRequest({ ...request, postcode: e.target.value })}
                                                    />
                                                </div>
                                                <div className="col-8 mb-2">
                                                    <label htmlFor="widerrufCity" className="form-label visually-hidden">
                                                        Ort
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="widerrufCity"
                                                        placeholder="Ort"
                                                        aria-label="Ort"
                                                        value={request.city ? request.city : ''}
                                                        onChange={(e: any) => setRequest({ ...request, city: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="mb-2">
                                                <label htmlFor="widerrufEmail" className="form-label visually-hidden">
                                                    E-Mail
                                                </label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    id="widerrufEmail"
                                                    placeholder="E-Mail"
                                                    aria-label="E-Mail"
                                                    value={request.eMail ? request.eMail : ''}
                                                    onChange={(e: any) => setRequest({ ...request, eMail: e.target.value })}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label htmlFor="widerrufTelephone" className="form-label visually-hidden">
                                                    Telefon
                                                </label>
                                                <input
                                                    type="tel"
                                                    className="form-control"
                                                    id="widerrufTelephone"
                                                    placeholder="Telefon"
                                                    aria-label="Telefon"
                                                    value={request.telephone ? request.telephone : ''}
                                                    onChange={(e: any) => setRequest({ ...request, telephone: e.target.value })}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label htmlFor="widerrufContractDate" className="form-label small mb-1">
                                                    Tag des Vertragsabschlusses
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="widerrufContractDate"
                                                    aria-label="Tag des Vertragsabschlusses"
                                                    value={request.contractDate ? request.contractDate : ''}
                                                    onChange={(e: any) => setRequest({ ...request, contractDate: e.target.value })}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label htmlFor="widerrufObject" className="form-label visually-hidden">
                                                    Objekt / Vertragsbezeichnung
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="widerrufObject"
                                                    placeholder="Objekt / Vertragsbezeichnung (optional)"
                                                    aria-label="Objekt / Vertragsbezeichnung"
                                                    value={request.objectDescription ? request.objectDescription : ''}
                                                    onChange={(e: any) => setRequest({ ...request, objectDescription: e.target.value })}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="widerrufCustomText" className="form-label visually-hidden">
                                                    Weitere Mitteilung
                                                </label>
                                                <textarea
                                                    className="form-control"
                                                    id="widerrufCustomText"
                                                    placeholder="Weitere Mitteilung (optional)"
                                                    aria-label="Weitere Mitteilung"
                                                    rows={3}
                                                    value={request.customText ? request.customText : ''}
                                                    onChange={(e: any) => setRequest({ ...request, customText: e.target.value })}
                                                />
                                            </div>
                                            <div className="d-grid">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => sendWiderruf()}
                                                    disabled={
                                                        request &&
                                                        (!request.eMail ||
                                                            !request.lastName ||
                                                            !request.firstName ||
                                                            !request.anrede ||
                                                            request.anrede === 'Anrede')
                                                    }
                                                >
                                                    Widerruf bestätigen
                                                </button>
                                            </div>
                                        </form>
                                        {/* End Form */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {requestSuccessful && (
                        <div className="col-lg-12 mt-5">
                            <div className="alert alert-soft-success" role="alert">
                                <h4 className="alert-heading">Ihr Widerruf ist bei uns eingegangen.</h4>
                                <p className="mb-0">
                                    Wir haben Ihre Widerrufserklärung erhalten und übermitteln Ihnen in Kürze auf einem dauerhaften Datenträger (z. B. per E-Mail) eine Eingangsbestätigung mit
                                    Informationen zum Inhalt der Widerrufserklärung sowie dem Datum und der Uhrzeit ihres Eingangs. Wir prüfen anschließend, ob der Widerruf wirksam erklärt worden
                                    ist.
                                </p>
                            </div>
                        </div>
                    )}
                </div>

                <div id="stickyBlockEndPointWiderruf" />
            </div>
        </>
    );
};

export default WiderrufPage;
